export const DISTRIBUTOR_LEVELS = ["普通分銷", "核心分銷", "特約經銷", "管理員"] as const;
export type DistributorLevel = (typeof DISTRIBUTOR_LEVELS)[number];

export type KycStatus = "未認證" | "審核中" | "已通過" | "已拒絕";

export interface KycData {
  realName: string;
  idNumber: string;
  frontPhoto: string;
  backPhoto: string;
  holdingPhoto?: string;
  status: KycStatus;
  submittedAt?: string;
  reviewedAt?: string;
  adminNote?: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  phone: string;
  password?: string;
  balance: number;
  pendingBalance: number;
  level: string;
  role: "admin" | "user";
  avatar?: string;
  notes?: string;
  createdAt: string;
  totalOrders?: number;
}

export interface RechargeRequest {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  amount: number;
  transferCode: string;
  voucherUrl: string;
  status: "待審核" | "通過" | "拒絕";
  adminNote?: string;
  createdAt: string;
  reviewedAt?: string;
}

export const mockUsers: User[] = [
  {
    id: "u001",
    name: "王小明",
    email: "xiaoming@example.com",
    phone: "0912-345-678",
    password: "123456",
    level: "普通分銷",
    balance: 12800,
    pendingBalance: 3000,
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%2C%20clean%20neutral%20background%2C%20warm%20lighting%2C%20confident%20smile%2C%20modern%20corporate%20style%20photography&width=100&height=100&seq=avatar001&orientation=squarish",
    role: "user",
    totalOrders: 12,
    createdAt: "2024-08-15",
  },
  {
    id: "u002",
    name: "陳美華",
    email: "meihua@example.com",
    phone: "0923-456-789",
    password: "123456",
    level: "普通分銷",
    balance: 5600,
    pendingBalance: 0,
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20portrait%20headshot%2C%20clean%20neutral%20background%2C%20warm%20lighting%2C%20friendly%20smile%2C%20modern%20corporate%20style%20photography&width=100&height=100&seq=avatar002&orientation=squarish",
    role: "user",
    totalOrders: 5,
    createdAt: "2024-10-20",
  },
  {
    id: "admin001",
    name: "系統管理員",
    email: "admin@jishi-trade.com",
    phone: "0900-000-000",
    password: "admin123",
    level: "管理員",
    balance: 0,
    pendingBalance: 0,
    totalOrders: 999,
    role: "admin",
    createdAt: "2024-01-01",
  },
];

export const mockRechargeRequests: RechargeRequest[] = [
  {
    id: "r001",
    userId: "u001",
    userName: "王小明",
    userEmail: "xiaoming@example.com",
    amount: 5000,
    transferCode: "34567",
    voucherUrl: "https://readdy.ai/api/search-image?query=bank%20wire%20transfer%20receipt%20slip%20document%2C%20taiwan%20banking%20system%2C%20printed%20receipt%20paper%20with%20transaction%20details%2C%20realistic%20financial%20document%20photography&width=600&height=400&seq=voucher001&orientation=landscape",
    status: "待審核",
    createdAt: "2026-04-28 14:30",
  },
  {
    id: "r002",
    userId: "u002",
    userName: "陳美華",
    userEmail: "meihua@example.com",
    amount: 3000,
    transferCode: "89123",
    voucherUrl: "https://readdy.ai/api/search-image?query=bank%20wire%20transfer%20receipt%20document%20taiwan%20banking%2C%20printed%20paper%20receipt%20with%20amount%20and%20date%2C%20financial%20transaction%20proof%2C%20clean%20document%20photography&width=600&height=400&seq=voucher002&orientation=landscape",
    status: "通過",
    createdAt: "2026-04-25 09:15",
    reviewedAt: "2026-04-25 11:00",
  },
  {
    id: "r003",
    userId: "u001",
    userName: "王小明",
    userEmail: "xiaoming@example.com",
    amount: 8000,
    transferCode: "56789",
    voucherUrl: "https://readdy.ai/api/search-image?query=mobile%20banking%20transfer%20screenshot%20taiwan%20bank%20app%2C%20showing%20transaction%20details%20and%20amount%2C%20smartphone%20screen%20financial%20app%2C%20clean%20digital%20receipt&width=600&height=400&seq=voucher003&orientation=landscape",
    status: "通過",
    createdAt: "2026-04-20 16:45",
    reviewedAt: "2026-04-21 09:00",
  },
  {
    id: "r004",
    userId: "u002",
    userName: "陳美華",
    userEmail: "meihua@example.com",
    amount: 2000,
    transferCode: "12345",
    voucherUrl: "https://readdy.ai/api/search-image?query=atm%20deposit%20receipt%20taiwan%20bank%2C%20printed%20paper%20receipt%20from%20automated%20teller%20machine%2C%20financial%20transaction%20proof%20document%2C%20realistic%20photography&width=600&height=400&seq=voucher004&orientation=landscape",
    status: "拒絕",
    createdAt: "2026-04-18 10:00",
    reviewedAt: "2026-04-18 14:30",
    adminNote: "匯款金額與申請金額不符",
  },
  {
    id: "r005",
    userId: "u001",
    userName: "王小明",
    userEmail: "xiaoming@example.com",
    amount: 10000,
    transferCode: "98765",
    voucherUrl: "https://readdy.ai/api/search-image?query=bank%20wire%20transfer%20receipt%20taiwan%20financial%20document%2C%20showing%20large%20amount%20transaction%2C%20clean%20professional%20document%20photography%20with%20transaction%20details&width=600&height=400&seq=voucher005&orientation=landscape",
    status: "待審核",
    createdAt: "2026-04-29 11:20",
  },
];

export const mockBankInfo = {
  bankName: "台灣銀行",
  accountName: "吉時國際貿易股份有限公司",
  accountNumber: "012-1234-5678-9012",
  branch: "台北信義分行",
  note: "轉帳完成後請記得填寫後五碼並上傳憑證",
};